// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-ar__form textarea{resize:vertical !important}.close-ar__inputs{padding:20px 21px 0px 21px;width:unset !important}", ""]);
// Exports
module.exports = exports;
